export default __webpack_public_path__ + "static/media/Stage2_clueicon_normal.43ba01f9.svg";